import { Link } from 'react-router-dom';
import React from 'react';
import { Phone, Mail, MapPin, Shield, Clock, ArrowUp } from 'lucide-react';
import { companyInfo, services } from '../mockData';
import NAPConsistency from './NAPConsistency';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ 
      backgroundColor: 'var(--bg-page)', 
      borderTop: '1px solid var(--border-medium)',
      position: 'relative'
    }}>
      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        style={{
          position: 'absolute',
          top: '-25px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '50px',
          height: '50px',
          backgroundColor: 'var(--brand-primary)',
          border: 'none',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
        className="back-to-top"
      >
        <ArrowUp size={20} color="var(--text-inverse)" />
      </button>

      <div className="container">
        {/* Main Footer Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
          gap: '3rem',
          padding: '4rem 0 3rem 0'
        }} className="footer-grid">
          
          {/* Company Info */}
          <div>
            <h3 className="heading-3" style={{ 
              marginBottom: '1.5rem',
              fontSize: '1.5rem',
              color: 'var(--brand-primary)'
            }}>
              {companyInfo.name}
            </h3>
            
            <p className="body-small" style={{ 
              color: 'var(--text-secondary)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              California-based legal document specialists. We help our California clients execute professional legal support services nationwide. Registered, bonded, and trusted by law firms and individuals.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3" style={{ 
              marginBottom: '1.5rem',
              fontSize: '1.2rem'
            }}>
              Our Services
            </h4>
            
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              {services.map((service) => (
                <li key={service.id}>
                  <button
                    onClick={() => scrollToSection('services')}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'var(--text-secondary)',
                      fontSize: '0.9rem',
                      cursor: 'pointer',
                      transition: 'color 0.3s ease',
                      textAlign: 'left',
                      padding: 0
                    }}
                    className="footer-link"
                  >
                    {service.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3" style={{ 
              marginBottom: '1.5rem',
              fontSize: '1.2rem'
            }}>
              Quick Links
            </h4>
            
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem'
            }}>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    textAlign: 'left',
                    padding: 0
                  }}
                  className="footer-link"
                >
                  About Us
                </button>
              </li>
              {/* <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    textAlign: 'left',
                    padding: 0
                  }}
                  className="footer-link"
                >
                  Testimonials
                </button>
              </li> */} {/* Hidden until we have enough testimonials */}
              <li>
                <Link to="/quote" style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    textAlign: 'left',
                    padding: 0,
                    textDecoration: 'none'
                  }} className="footer-link" data-testid="footer-get-quote-link">Get Quote</Link>
              </li>
              <li>
                <Link to="/status" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', textDecoration: 'none' }} className="footer-link" data-testid="footer-status-link">Check Request Status</Link>
              </li>
              <li>
                <Link to="/portal" style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', textDecoration: 'none' }} className="footer-link" data-testid="footer-portal-link">Client Portal</Link>
              </li>
              <li>
                <a 
                  href="/privacy"
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    textAlign: 'left',
                    padding: 0,
                    textDecoration: 'none'
                  }}
                  className="footer-link"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="/eula"
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    textAlign: 'left',
                    padding: 0,
                    textDecoration: 'none'
                  }}
                  className="footer-link"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info - NAP Consistency */}
          <div>
            <h4 className="heading-3" style={{ 
              marginBottom: '1.5rem',
              fontSize: '1.2rem'
            }}>
              Contact Information
            </h4>
            
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '1rem'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Phone size={16} color="var(--brand-primary)" />
                <a href={`tel:${companyInfo.phone}`} style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>
                  <span className="body-small">
                    {companyInfo.phone}
                  </span>
                </a>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <Mail size={16} color="var(--brand-primary)" />
                <a href={`mailto:${companyInfo.email}`} style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>
                  <span className="body-small">
                    {companyInfo.email}
                  </span>
                </a>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <MapPin size={16} color="var(--brand-primary)" style={{ marginTop: '0.25rem' }} />
                <div>
                  <span className="body-small" style={{ color: 'var(--text-primary)', display: 'block' }}>
                    {companyInfo.fullAddress}
                  </span>
                  <span className="caption" style={{ color: 'var(--text-secondary)' }}>
                    Serving All 58 California Counties
                  </span>
                </div>
              </div>
              
              {/* Citation-Ready Business Info */}
              <div style={{
                backgroundColor: 'var(--bg-card)',
                padding: '1rem',
                borderRadius: '6px',
                border: '1px solid var(--border-light)',
                marginTop: '0.5rem'
              }}>
                <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: '1.4' }}>
                  <p style={{ margin: '0.25rem 0', color: 'var(--text-primary)', fontWeight: '600' }}>
                    Legal Document Specialist
                  </p>
                  <p style={{ margin: '0.25rem 0' }}>
                    License: Registered & Bonded Process Servers
                  </p>
                  <p style={{ margin: '0.25rem 0' }}>
                    Established: 2003 | California Legal Services
                  </p>
                  <p style={{ margin: '0.25rem 0' }}>
                    Specializing: Attorney Services, Process Serving, Court Filing
                  </p>
                </div>
              </div>

              {/* Business Hours */}
              <div style={{
                marginTop: '1rem',
                padding: '1rem',
                backgroundColor: 'var(--bg-card)',
                borderRadius: '8px',
                border: '1px solid var(--border-medium)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <Clock size={16} color="var(--brand-primary)" />
                  <span className="caption" style={{ color: 'var(--text-primary)' }}>
                    BUSINESS HOURS
                  </span>
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: '1.4' }}>
                  <p style={{ margin: '0.25rem 0' }}>Mon-Fri: 9AM-5PM PST</p>
                  <p style={{ margin: '0.25rem 0' }}>Sat-Sun: Closed</p>
                  <p style={{ margin: '0.25rem 0' }}>E-Filing: 24/7 Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div style={{
          borderTop: '1px solid var(--border-medium)',
          paddingTop: '2rem',
          paddingBottom: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1.5rem',
            flexWrap: 'wrap'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 1rem',
              backgroundColor: 'var(--bg-card)',
              borderRadius: '20px',
              border: '1px solid var(--border-medium)'
            }}>
              <Shield size={14} color="var(--brand-primary)" />
              <span className="caption" style={{ color: 'var(--text-secondary)' }}>
                Registered in Operating Counties
              </span>
            </div>
            
            <Link to="/quote" className="btn-primary" data-testid="footer-get-free-quote-link" style={{ fontSize: '0.9rem', padding: '0.75em 1.5em', minHeight: '40px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>
              Get Free Quote
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        .back-to-top:hover {
          transform: translateX(-50%) scale(1.1);
          background-color: var(--brand-hover) !important;
        }

        .footer-link:hover {
          color: var(--brand-primary) !important;
        }

        @media (max-width: 1199px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 2rem !important;
          }
        }

        @media (max-width: 767px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
            padding: 3rem 0 2rem 0 !important;
          }
          
          div[style*="justifyContent: 'space-between'"] {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 1rem !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;